import React, { useState } from "react";
import { TestGrid } from "./test-grid";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { Headphones, Book, Pencil, Mic, LayoutGrid } from "lucide-react";
import { CompletedTestsPage } from "./completed-tests-page";
import { levelColors } from "../components/levelColors";

const SKILLS = [
  { id: "Listening", icon: Headphones },
  { id: "Reading", icon: Book },
  { id: "Writing", icon: Pencil },
  { id: "Speaking", icon: Mic },
  { id: "All", icon: LayoutGrid },
];
const TestsPage = ({
  testsData,
  selectedLevel,
  activeSection,
  onSectionChange,
  Upgradetoggle,
}) => {
  const [selectedSkill, setSelectedSkill] = useState("Listening");


  const getFilteredTests = (testsData, skill_id, selectedLevel) => {
    if (!testsData || !testsData[selectedLevel]) {
      return [];
    }

    const levelTests = testsData[selectedLevel] || [];
    const levelTestsArray = levelTests["tests"];

    const filteredTests = levelTestsArray.filter(
      (test) => test.test_type === skill_id && test.status !== "Task completed"
    );

    return filteredTests;
  };

  const getAllTests = () => {
    if (!testsData || !testsData[selectedLevel]) {
      return [];
    }

    const levelTests = testsData[selectedLevel] || {};
    const levelTestsArray = levelTests["tests"] || [];

    return levelTestsArray.filter(
      (test) =>
        ["Listening", "Reading", "Writing", "Speaking"].includes(
          test.test_type
        ) && test.status !== "Task completed"
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-3">
      <div className="pt-24 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          {activeSection === "tests" && (
            <>
              {/* <AIFeedbackBanner onLearnMore={() => setShowLearnMore(true)} /> */}
              <Tabs
                value={selectedSkill}
                onValueChange={(value) => setSelectedSkill(value)}
              >
                <TabsList className="grid w-full grid-cols-5 gap-4 bg-transparent p-0">
                  {SKILLS.map((skill) => (
                    <TabsTrigger
                      key={skill.id}
                      value={skill.id}
                      className={`flex items-center justify-center gap-2 p-3 rounded-lg transition-all duration-200 ${
                        selectedSkill === skill.id
                          ? `bg-gradient-to-r ${levelColors[selectedLevel]} text-white shadow-md`
                          : "bg-white text-gray-600 hover:bg-gray-100"
                      }`}
                    >
                      <skill.icon className="w-5 h-5" />
                      {skill.id}
                    </TabsTrigger>
                  ))}
                </TabsList>
                {SKILLS.map((skill) => (
                  <TabsContent key={skill.id} value={skill.id} className="mt-6">
                    <TestGrid
                      tests={
                        skill.id === "All"
                          ? getAllTests()
                          : getFilteredTests(testsData, skill.id, selectedLevel)
                      }
                      level={selectedLevel}
                      Upgradetoggle={Upgradetoggle}
                    />
                  </TabsContent>
                ))}
              </Tabs>
            </>
          )}
          {activeSection === "completed" && (
            <CompletedTestsPage
              AlltestsData={testsData}
              NewselectedLevel={selectedLevel}
              onSectionChange={onSectionChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default TestsPage;
